import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { StatusMessage } from '../interfaces/message-status.interface';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StatusMessageService {
  private platformId = inject(PLATFORM_ID);

  private _dialogSubj$: Subject<'accept' | 'deny' | string> = new Subject<'accept' | 'deny' | string>();
  get dialogSubj$(): Observable<'accept' | 'deny' | string> {
    return this._dialogSubj$.asObservable().pipe(
      filter(() => isPlatformBrowser(this.platformId))
    );
  }

  private _statusMessage: Subject<StatusMessage> = new Subject<StatusMessage>();

  get statusMessage$(): Observable<StatusMessage> {
    return this._statusMessage.asObservable().pipe(
      filter(() => isPlatformBrowser(this.platformId))
    );
  }

  setStatusMessage(status: StatusMessage): void {
    this._statusMessage.next(status);
  }

  setDialogState(key: 'accept' | 'deny' | string): void {
    this._dialogSubj$.next(key);
  }
}
